import { render, staticRenderFns } from "./EmbeddedPage.vue?vue&type=template&id=9156bfe2&scoped=true&"
import script from "./EmbeddedPage.vue?vue&type=script&lang=js&"
export * from "./EmbeddedPage.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedPage.vue?vue&type=style&index=0&id=9156bfe2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9156bfe2",
  null
  
)

export default component.exports